import { Backend } from '@/_axios';

export default {
  list(params) {
    return Backend.get('/error_reports', { params });
  },
  view(id) {
    return Backend.get(`/error_reports/${id}`);
  },
  download(id, log) {
    return Backend.get(`/error_reports/${id}/download/${log}`, { responseType: 'blob' });
  }
};
